import React from "react";

import { ChevronLeftIcon as ChevronLeft, Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import {
  ProcessSignalName,
  ProcessSignalNumber
} from "Api/adminAgent/types/ProcessSignal.enum";
import { ServiceProcess } from "Api/adminAgent/types/ServiceProcess.type";
import * as Dialog from "ds/Dialog";
import * as Dropdown from "ds/Dropdown";
import { useOpenProcessActionModal } from "Reducers/serviceProcesses/hooks/useOpenProcessActionModal";

import { processSignals } from "../utils/processSignals";

import * as S from "./AdvancedOptionsDialog.styles";

export type AdvancedOptionsDialogProps = {
  process: ServiceProcess;
  onClick: () => void;
};

export const AdvancedOptionsDialog = ({
  process,
  onClick
}: AdvancedOptionsDialogProps) => {
  const { formatMessage } = useIntl();
  const openProcessActionModal = useOpenProcessActionModal();

  const onOpenModal = (
    process: ServiceProcess,
    processSignal: ProcessSignalNumber
  ) => {
    onClick();
    openProcessActionModal(process, processSignal);
  };

  return (
    <Dialog.Root open={true}>
      <Dialog.Trigger>
        <Dropdown.Item
          onClick={event => {
            event.preventDefault();
          }}
        >
          <ChevronLeft />

          {formatMessage({
            id: "services.process.options.advanced_signals"
          })}
        </Dropdown.Item>
      </Dialog.Trigger>
      <S.CustomDialogContent
        align="end"
        side="left"
        sideOffset={0}
        alignOffset={-8}
      >
        <Typography.BodyText weight="semiBold" size="medium">
          {formatMessage({
            id: "services.process.options.dialog.title"
          })}
        </Typography.BodyText>

        <S.AdvancedDialogOptions>
          {processSignals.map(processSignal => (
            <S.DialogOptionsCell key={processSignal}>
              <S.DialogOptionsButton
                variant="link"
                analyticId={ProcessSignalName[processSignal]}
                onClick={() => {
                  onOpenModal(process, processSignal);
                }}
              >
                ({processSignal}) {ProcessSignalName[processSignal]}
              </S.DialogOptionsButton>
            </S.DialogOptionsCell>
          ))}
        </S.AdvancedDialogOptions>

        <S.AdvancedSignalsDoc>
          <Typography.BodyText size="small">
            {formatMessage({
              id: "services.process.options.dialog.more_information"
            })}
          </Typography.BodyText>
          <S.DocButton
            to="https://man7.org/linux/man-pages/man7/signal.7.html"
            analyticId="services.process.options.dialog.view_documentation"
          >
            {formatMessage({
              id: "services.process.options.dialog.view_documentation"
            })}
          </S.DocButton>
        </S.AdvancedSignalsDoc>
      </S.CustomDialogContent>
    </Dialog.Root>
  );
};
